export const stateScreenShotsApprove = {
  WAIT_FOR_APPROVE: 'WAIT_FOR_APPROVE',
  REJECTED_APPROVE: 'REJECTED_APPROVE',
  APPROVED: 'APPROVED',
  UNSET: 'UNSET',
};
